/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Aoun.Api
 * OpenAPI spec version: 1.0
 */

export type MissionType = typeof MissionType[keyof typeof MissionType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MissionType = {
  Missing: 'Missing',
  Stranded: 'Stranded',
  SubMission: 'SubMission',
} as const;
